/**
 * 予約販売: 販売開始までのカウントダウンと、開始時刻での購入ボタン自動切替
 *
 * - snippets/buy-buttons.liquid が開始前に出力する購入ボタン
 *     <button data-release-start="UNIX秒" data-section-id data-product-url ...>
 *   と、その直後の <p data-release-countdown> を対象にする
 * - 1秒ごとに「販売開始まで あと ○日 ○時間○分○秒」を表示
 * - 開始時刻になったら、商品セクションをサーバーから再取得し（サーバー側の判定が正）、
 *   ボタンが有効になっていれば disabled・ラベルを更新して「カートに追加する」に切り替える。
 *   ボタン要素は差し替えず属性だけ更新するので product-form のイベントリスナーは壊れない
 * - 端末の時計がずれている場合に備え、残り10分以内は60秒ごとにもサーバー確認する
 * - 在庫欄（#Inventory-{sectionId}）があればそれも最新化する
 * - 開始前に非表示だった Shop Pay 等の動的決済ボタンは、ページ再読み込みまで出ない（通常の購入ボタンは使える）
 */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function formatRemaining(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400); s %= 86400;
    var h = Math.floor(s / 3600); s %= 3600;
    var m = Math.floor(s / 60); s %= 60;
    var out = '';
    if (d > 0) out += d + '日 ';
    if (d > 0 || h > 0) out += h + '時間';
    out += m + '分' + pad(s) + '秒';
    return out;
  }

  function init(btn) {
    var start = parseInt(btn.dataset.releaseStart || '0', 10) * 1000;
    if (!start) return;
    var sectionId = btn.dataset.sectionId;
    var productUrl = btn.dataset.productUrl;
    var form = btn.closest('product-form') || document;
    var cd = form.querySelector('[data-release-countdown]');
    var burstStarted = false;
    var released = false;

    function setCountdown(text) {
      if (!cd) return;
      cd.hidden = false;
      cd.textContent = text;
    }

    /** サーバーから最新のボタン状態を取得して反映。有効化できたら true */
    function refresh() {
      if (!sectionId || !productUrl) return Promise.resolve(false);
      var url = productUrl + '?section_id=' + encodeURIComponent(sectionId) + '&_=' + Date.now();
      return fetch(url, { cache: 'no-store' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById(btn.id);
          if (!fresh) return false;
          var freshLabel = fresh.querySelector('span');
          var curLabel = btn.querySelector('span');
          var enabled = !fresh.disabled && !fresh.classList.contains('button--pre-launch');
          if (enabled) {
            btn.disabled = false;
            btn.classList.remove('button--pre-launch');
            btn.removeAttribute('data-release-start');
            if (curLabel && freshLabel) curLabel.textContent = freshLabel.textContent;
            if (cd) cd.hidden = true;
            released = true;
          } else if (curLabel && freshLabel && freshLabel.textContent.trim()) {
            curLabel.textContent = freshLabel.textContent;
          }
          // 同一オリジンの自ストアが描画したセクションHTMLを反映（既存の在庫自動更新と同じ扱い）
          var inv = document.getElementById('Inventory-' + sectionId);
          var freshInv = doc.getElementById('Inventory-' + sectionId);
          if (inv && freshInv) inv.innerHTML = freshInv.innerHTML;
          return enabled;
        })
        .catch(function () { return false; });
    }

    /** 開始時刻到来: 6秒おきに最大30回（3分）サーバー確認して切り替える */
    function startBurst() {
      if (burstStarted) return;
      burstStarted = true;
      setCountdown('まもなく販売開始します…');
      var n = 0;
      var run = function () {
        refresh().then(function (ok) {
          if (ok || released) return;
          if (++n >= 30) {
            setCountdown('販売を開始しました。ページを再読み込みしてください。');
            return;
          }
          setTimeout(run, 6000);
        });
      };
      run();
    }

    function tick() {
      if (released) { clearInterval(timer); return; }
      var rem = start - Date.now();
      if (rem > 0) {
        setCountdown('販売開始まで あと ' + formatRemaining(rem));
      } else {
        clearInterval(timer);
        startBurst();
      }
    }
    var timer = setInterval(tick, 1000);
    tick();

    // 端末時計のズレ対策: 残り10分以内は60秒ごとにサーバー確認（開始済みなら切り替わる）
    var guard = setInterval(function () {
      if (released) { clearInterval(guard); return; }
      if (start - Date.now() < 10 * 60 * 1000) refresh();
    }, 60000);
  }

  function boot() {
    document.querySelectorAll('[data-release-start]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
